import { render, staticRenderFns } from "./ButtonInspectGroup.vue?vue&type=template&id=0387a9f5&"
import script from "./ButtonInspectGroup.vue?vue&type=script&lang=ts&"
export * from "./ButtonInspectGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports